import ShowChartIcon from "@material-ui/icons/ShowChart";
import Metrics from "./metricsView.js";

export default {
  list: Metrics,
  icon: ShowChartIcon,
};
